import Papa from 'papaparse';

function normalizeHeader(value='') {
  return value.replace(/^\uFEFF/, '').toLowerCase().replace(/[\s_-]+/g, '');
}

export function createWorkflowBatchCsv(rows=[]) {
  if( rows.length === 0 ) return '';
  return Papa.unparse(rows, { header: true, newline: '\n' });
}

export function parseWorkflowBatchCsv(csv_text='') {
  if( !csv_text.trim() ) return { batchesToUpdate: [] };

  const parsed = Papa.parse(csv_text, {
    header: true,
    skipEmptyLines: 'greedy',
  });

  const fatal_error = parsed.errors.find(error => error.type === 'Quotes' || error.type === 'Delimiter');
  if( fatal_error ) throw new Error(`Unable to parse CSV at line ${fatal_error.row + 1}: ${fatal_error.message}`);

  const headers = parsed.meta.fields || [];
  const batch_header = headers.find(header => ['batchname', 'name'].includes(normalizeHeader(header)));
  const update_header = headers.find(header => ['updatevalue', 'priority'].includes(normalizeHeader(header)));

  if( !batch_header || !update_header ) {
    throw new Error(
      `CSV must include batch and update columns. Accepted headers: BatchName or name; UpdateValue or priority. Found: ${headers.join(', ')}`
    );
  }

  const batchesToUpdate = parsed.data.map((row, index) => {
    const batchName = String(row[batch_header] ?? '').trim();
    const updateValue = parseInt(String(row[update_header] ?? '').trim(), 10);

    if( !batchName || Number.isNaN(updateValue) ) {
      throw new Error(
        `Missing required values (BatchName/name or UpdateValue/priority) at line ${index + 2}. UpdateValue/priority must be an integer.`
      );
    }

    return { batchName, updateValue };
  });

  return { batchesToUpdate };
}
